import * as React from 'react'
import PropTypes from 'prop-types'

import noScroll from '../../libs/noScroll'
import { KeyboardArrowDownIcon, MenuIcon, CloseIcon } from '../../icons'
import {
  MobileMenuWrapper,
  MobileMenuButton,
  MobileMenuButtonContent,
  MobileMenuContent,
  HeaderBackground,
  ScrollContainer,
  HamburgerButtonContent,
  UnreadCountWrapper,
} from './style'

import GigRequestUnreadCount from '../../containers/gig-request-unread-count'

const HeaderMenuMobileWrapper = ({ children, useHamburger, forEventplanner, forArtist }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  // const inputEl = useRef(null)

  const closeMenu = e => {
    e.stopPropagation()
    setIsOpen(false)
    noScroll.off()
  }

  const openMenu = () => {
    setIsOpen(true)
    window.scrollTo(0, 0) // ensure top position
    noScroll.on()
  }

  return (
    <>
      <MobileMenuButton
        useHamburger={useHamburger}
        onClick={!isOpen ? openMenu : closeMenu}
        aria-label="Hovednavigasjonsmeny"
        aria-haspopup="true"
      >
        {useHamburger ? (
          <HamburgerButtonContent>{isOpen ? <CloseIcon /> : <MenuIcon />}</HamburgerButtonContent>
        ) : (
          <MobileMenuButtonContent isOpen={isOpen}>
            <span>Meny</span>
            <KeyboardArrowDownIcon />
            {!isOpen ? (
              <UnreadCountWrapper>
                <GigRequestUnreadCount forEventplanner={forEventplanner} forArtist={forArtist} />
              </UnreadCountWrapper>
            ) : null}
          </MobileMenuButtonContent>
        )}
      </MobileMenuButton>
      <MobileMenuWrapper>
        <MobileMenuContent isOpen={isOpen} onClick={closeMenu}>
          {isOpen ? <ScrollContainer>{children}</ScrollContainer> : null}
        </MobileMenuContent>
        {isOpen ? <HeaderBackground onClick={closeMenu} /> : null}
      </MobileMenuWrapper>
    </>
  )
}

HeaderMenuMobileWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  useHamburger: PropTypes.bool,
  forEventplanner: PropTypes.bool,
  forArtist: PropTypes.bool,
}

HeaderMenuMobileWrapper.defaultProps = {
  useHamburger: false,
  forEventplanner: false,
  forArtist: false,
}

export default React.memo(HeaderMenuMobileWrapper)
